import React from 'react'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import EditIcon from '@material-ui/icons/Edit';
import AsyncStorage from '@callstack/async-storage';

export default class Mainmenu extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      user: {
        roles: []
      }
    }
  }



  async componentWillMount(){
    let session = await AsyncStorage.multiGet(["user","uid"])
    let user = JSON.parse( session[0][1] )
    this.setState({user: user})
  }

  render(){
     return (
      <div>
       { this.state.user.roles.includes("admin") && 
        <ListItem selected = { (this.props.active=='users') && 'true' } button onClick={() => this.props.navigation.navigate("Users")}>
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Users" />
        </ListItem>
       }

       {  ( this.state.user.roles.includes("admin") || this.state.user.roles.includes("seller") ) && 
        <ListItem selected = {this.props.active=='inventory' && 'true'} button onClick={() => this.props.navigation.navigate("Inventory")}>
              <ListItemIcon>
                <StoreIcon />
              </ListItemIcon>
              <ListItemText primary="Inventory" />
        </ListItem>
       }

       { this.state.user.roles.includes("admin") &&
        <ListItem selected = {this.props.active=='orders' && 'true'} button onClick={() => this.props.navigation.navigate("Orders")}>
              <ListItemIcon>
                <ShoppingCartIcon />
              </ListItemIcon>
              <ListItemText primary="Orders" />
        </ListItem>
       }
          {/*<ListItem button onClick={() => this.goTo("Tracker")}>
            <ListItemIcon>
              <PersonPinIcon />
            </ListItemIcon>
            <ListItemText primary="Tracker" />
          </ListItem>
          <ListItem className={ !(!this.state.user.roles.includes("admin") && this.state.user.roles.includes("seller")) && classes.hide} button onClick={() => this.goTo("Wallet")}>
            <ListItemIcon>
              <CreditCardIcon />
            </ListItemIcon>
            <ListItemText primary="Wallet" />
          </ListItem>*/}
        { this.state.user.roles.includes("admin") &&
          <ListItem selected = { this.props.active=='productrequest' && 'true' } button onClick={() => this.props.navigation.navigate("ProductRequests")}>
                <ListItemIcon>
                  <SwapHorizIcon />
                </ListItemIcon>
                <ListItemText primary="Product Requests" />
          </ListItem>
        }

        { this.state.user.roles.includes("admin") &&
          <ListItem selected = { this.props.active=='config' && 'true' } button onClick={() => this.props.navigation.navigate("Config")}>
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText primary="Config"/>
          </ListItem>
        }
      </div>
          
    )
  }
}
